import addressSearchRequest from '../../libs/requests/addressSearch';
import usernameSearch from '../../libs/requests/usernameSearch';
import { getSupplier, supplierKey } from '../../libs/sessionVariable';
import { getIsLayer2 } from '../../libs/sessionVariable';
import { generateShortID } from "../../libs/utils";
import { lookupAppointment } from '../../libs/requests/orderSearch';

export async function fetchAppointmentDetails(details) {
  if (!details) return null;

  const availability = JSON.parse(details);
  const appointmentDetails = await lookupAppointment(
    availability?.orderDetails?.availabilityReference,
    availability?.productCode,
    availability?.orderDetails?.goldAddressKeyAvailabilityRequest?.addressReferenceNumber || "",
    availability?.orderDetails?.goldAddressKeyAvailabilityRequest?.districtCode || "",
    "All"
  );

  return appointmentDetails;
}


export const routerOptions = [
  { key: 'None', value: 'None', text: 'No Router' },
  { key: 'Draytek 2865ax', value: 'Draytek 2865ax', text: 'Draytek 2865ax' },
  { key: 'Zyxel VMG8623-T50', value: 'Zyxel VMG8623-T50', text: 'Zyxel VMG8623-T50' },
];

export const deliveryOptions = [
  { key: 'None', value: '', text: 'None' }, 
  { key: 'next', value: 'NextDay', text: 'Next Day Delivery' },
  { key: 'two', value: 'TwoDay', text: 'Two Day Delivery' },
];

export const careLevels = [
    { key: 0, value: 'Standard', text: 'Standard', flag: 0 },
    { key: 1, value: 'Enhanced', text: 'Enhanced', flag: 1 },
    { key: 2, value: 'Critical', text: 'Critical', flag: 2 },
  ];

  export const trafficWeighting = [
    { key: 0, value: 'Standard', text: 'Standard', flag: 0 }
  ]

  export const ips = [
    { key: 1, value: 1, text: '1', flag: 1 },
    { key: 4, value: 4, text: '4', flag: 4 }
  ]

  // Get postcode
  export const getPostCode = (product) => {
    let btPostcode = product?.orderDetails?.lineCharacteristics?.btOpenreachPostCode ? product?.orderDetails?.lineCharacteristics?.btWholesalePostCode : product?.orderDetails?.lineCharacteristics?.btOpenreachPostCode;
    if (btPostcode) {
      return { 'postCode': btPostcode };
    }
    return { 'postCode': product?.orderDetails?.request?.postCode };
  }

  // Address Search
  export const addressSearch = async (postCode) => {
    try {
      return await addressSearchRequest(postCode);
    } catch (err) {
      console.log(err);
    }
  }

  export const getAddresses = async (postCode) => {
    const result = await addressSearch(postCode)
    const optionsList = [];

    result.forEach(function (element) {
      optionsList.push({ key: element.addressReference, value: element.addressReference, text: element.address, flag: element.addressReference })
    })
    return optionsList;
  }

  export const usernameCheck = async (username) => {
    try {
      return await usernameSearch(username);
    } catch (err) {
    }
  }

  export async function fetchSuppllier() {
    return await getSupplier(supplierKey.ZEN, false);
  }

  export async function getAddressResults(postCode) {
    await getAddresses(postCode.postCode)
  }

  export async function isL2(){
    return await getIsLayer2();
  }

  export const buildSogeaOrderPayload = ({
    values,
    product,
    selectedLine,
    postCode,
    addressResults,
    selectedAppointmentType,
    level,
    weighting,
    router,
    deliveryOptions,
    pricingOption,
    bespokePrice,
    isRetryOrder,
    isL2Customer,
    realm,
    permissions,
    productOptions,
    requierments,
    hasSelectedNewProvide,
    hasSelectedAccessLine,
    workingLineTakeover,
    selectedContractTerm,
    bureauEndCustomer,
    isBureauReseller

  }) => {
    const selectedAddress = values.addressField?.qualifier === "Gold"
      ? addressResults.find(
          (element) =>
            element.key.addressReferenceNumber ===
            values.addressField?.addressReferenceNumber
        )
      : addressResults.find(
          (element) => element.key.uprn === values.addressField?.uprn
        );
  
    const appointmentType =
      selectedAppointmentType ||
      (product?.allowedAppointmentTypes?.length
        ? product.allowedAppointmentTypes[0]
        : null);
  
    const addressDetails = selectedAddress.text;
    const address = addressDetails.split(",");
    const isPremiseNameOrThoroughfare = parseInt(address[0]);
    const usePremiseName = isNaN(isPremiseNameOrThoroughfare);
    const premiseName = usePremiseName ? address[0] : null;
    const thoroughFareNumber = !usePremiseName ? address[0] : null;
    
    let activationDate = !document.getElementById("activationDateField")
      ? ""
      : document.getElementById("activationDateField").defaultValue;
    let year = activationDate.substring(6, 10);
    let month = activationDate.substring(3, 5) - 1;
    let day = activationDate.substring(0, 2);
    let dateObject = new Date(year, month, day, 12, 0, 0);
    activationDate = dateObject.toISOString();
    
    let timeSlot =
      !document.getElementById("preferredTimeslotField") ||
      document.getElementById("preferredTimeslotField").innerText === "Any"
        ? 0
        : document.getElementById("preferredTimeslotField").innerText;
    
    let hazardNotes = !document.getElementById("siteSafetyNotesField")
      ? ""
      : document.getElementById("siteSafetyNotesField").value;
    let notes = !document.getElementById("sitevisitNotesField")
      ? ""
      : document.getElementById("sitevisitNotesField").value;
    let specialArrangementNotes = !document.getElementById(
      "specialArrangementNotesField"
    )
      ? ""
      : document.getElementById("specialArrangementNotesField").value;
  
    if (timeSlot === "AM") timeSlot = 1;
    if (timeSlot === "PM") timeSlot = 2;
  
    const javaObject = {
      availabilityReference: product.orderDetails.availabilityReference,
      contractTerm: parseInt(selectedContractTerm),
      installationDetails: {
        phoneNumber:
          typeof product.orderDetails.accessLines !== "undefined" &&
          product.orderDetails.accessLines.length > 0
            ? selectedLine?.lineNumber
            : "",
        goldAddressKey:
          typeof values.addressField?.addressReferenceNumber !== "undefined"
            ? values.addressField?.addressReferenceNumber
            : "",
        districtCode: values.addressField.districtCode,
        address: {
          premiseName: premiseName,
          thoroughfareNumber: thoroughFareNumber,
          thoroughfare: address[1],
          postTown: address[2].trim(),
          postCode: postCode.trim(),
        },
        uprn:
          typeof values.addressField?.uprn !== "undefined" ? values.addressField?.uprn : "",
      },
      productCode: product.productCode,
      preferredActivationDate: activationDate,
      orderReference: !isRetryOrder
        ? values.orderRef + "_" + generateShortID()
        : values.orderRef,
      rid: permissions.isNimansTenant ? 'GLT' : values.rid,
      endUserContact: {
        fullName: values.contactName,
        phoneNumber: values.contactTel,
      },
      ...(!isL2Customer
        ? {
            broadbandCredentials: {
              username: `${values.usernameField}@${realm}`,
              password: values.password,
              numberOfIps: parseInt(values.noOfIps),
            },
          }
        : {}),
      accessLineId:
        selectedLine?.lineType === "StoppedLine" || 
        (!hasSelectedNewProvide && hasSelectedAccessLine)
          ? selectedLine.accessLineId
          : "",
      workingLineTakeover: workingLineTakeover ?? false,
    };
  
    if (productOptions?.length > 0 && productOptions.some(x => x.code === "CareLevel") || productOptions.some(x => x.code === "TrafficWeighting")) {
      javaObject.options = [
        {
          type: 1,
          value: level.careLevelField,
        },
        {
          type: 2,
          value: weighting.trafficWeightingField,
        },
      ];
    }
  
    if (permissions?.rateCard && router !== 'None' && router !== '') {
      javaObject.router = router;
    }

    if (permissions?.rateCard && router !== 'None' && router !== '') {
      javaObject.deliveryOptions = deliveryOptions;
    }
  
    if (permissions?.rateCard) {
      javaObject.pricingOption = pricingOption;
      if (pricingOption === "bespoke") {
        javaObject.bespokePrice = bespokePrice;
      }
    }

    if(permissions?.isNimansTenant){
          javaObject.isBureauReseller = isBureauReseller;
          javaObject.bureauEndCustomer = bureauEndCustomer;
    }
      
  
    if (hasSelectedNewProvide || requierments?.some(x => x.name === "Appointment" && x.value === "Required")) {
      javaObject.appointment = {
        hazardNotes: hazardNotes,
        notes: notes,
        specialArrangementNotes: specialArrangementNotes,
        timeSlot: isNaN(parseInt(timeSlot)) ? 0 : parseInt(timeSlot),
        appointmentType: appointmentType,
      };
    }
  
    return JSON.stringify(javaObject);
  };

